<ng-template #purchaseModalTitleTpl>
  <div class="purchase-modal-title-wrap">
    <div class="purchase-modal-title">{{ purchaseModalTitleKey | i18n }}</div>
    <div class="purchase-modal-subtitle">{{ purchaseModalSubtitleKey | i18n }}</div>
  </div>
</ng-template>

<ng-template #selectorModalTitleTpl>
  <div class="purchase-modal-title-wrap">
    <div class="purchase-modal-title">{{ 'robot-service.my.title' | i18n }}</div>
    <div class="purchase-modal-subtitle">{{ selectorModalSubtitle }}</div>
  </div>
</ng-template>

<ng-template #crossTypeAttachConfirmTpl>
  <div class="cross-type-confirm">
    <div class="cross-type-confirm-hero">
      <div class="cross-type-confirm-icon">
        <i nz-icon nzType="warning" nzTheme="outline"></i>
      </div>
      <div class="cross-type-confirm-main">
        <div class="cross-type-confirm-title">{{ 'servicenumber.robot.attach.cross-type.title' | i18n }}</div>
        <div class="cross-type-confirm-desc">{{ crossTypeConfirmContent }}</div>
      </div>
    </div>

    <div class="cross-type-confirm-note">
      <i nz-icon nzType="info-circle" nzTheme="outline"></i>
      <span>{{ crossTypeConfirmNote }}</span>
    </div>
  </div>
</ng-template>

<div class="personal-robot-setting-container" [class.embedded-mode]="isEmbeddedInDetail" [testId]="'personal-robot-setting-container'">
  <div class="page-topbar">
    <div class="page-header title-only" [testId]="'personal-robot-page-header'">
      <div class="page-heading" [testId]="'personal-robot-page-heading'">
        <h3 class="page-title" [testId]="'personal-robot-page-title'">{{ 'servicenumber.robot.personal.title' | i18n }}</h3>
      </div>
      <div class="page-actions" [testId]="'personal-robot-page-actions'">
        <button
          nz-button
          nzType="primary"
          type="button"
          *ngIf="aiServiceStatus !== 'Active'"
          [nzLoading]="aiServiceLoading"
          (click)="setAiServiceStatus(true)"
          testId="enable-ai-service-button"
          >開啟 AI 服務</button
        >
        <button
          nz-button
          nzType="default"
          type="button"
          *ngIf="aiServiceStatus === 'Active'"
          [nzLoading]="aiServiceLoading"
          (click)="setAiServiceStatus(false)"
          testId="disable-ai-service-button"
          >關閉 AI 服務</button
        >
        <button
          nz-button
          [nzType]="hasUnsavedChanges ? 'primary' : 'default'"
          type="button"
          class="save-button"
          (click)="saveServiceRobot()"
          [nzLoading]="isSaving"
          [disabled]="!hasUnsavedChanges || isSaving || aiServiceStatus !== 'Active'"
          [testId]="'save-robot-button'"
        >
          <i nz-icon nzType="save" [testId]="'robot-save-icon'"></i>{{ 'common.save' | i18n }}
        </button>
      </div>
    </div>

    <div class="draft-banner" *ngIf="hasUnsavedChanges" [testId]="'personal-robot-unsaved-banner'">
      {{ 'servicenumber.robot.unsaved.content' | i18n }}
    </div>
  </div>

  <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n" class="page-spin" [testId]="'personal-robot-loading-spin'">
    <form
      nz-form
      nzLayout="vertical"
      [formGroup]="robotForm"
      (ngSubmit)="saveServiceRobot()"
      class="robot-settings-container"
      [testId]="'robot-settings-container'"
    >
      <div class="settings-surface" [testId]="'personal-robot-settings-surface'">
        <div class="section-card mode-card" [class.robot-config-locked]="!isRobotAttached" [testId]="'mode-card'">
          <div class="section-header" [testId]="'mode-card-header'">
            <h4 class="section-title">
              <span class="section-kicker"><i nz-icon nzType="appstore" nzTheme="outline"></i></span>
              {{ 'servicenumber.robot.ai-mode-settings' | i18n }}
            </h4>
          </div>
          <div class="mode-form">
            <div class="mode-item" [testId]="'mode-item-priority'">
              <div class="mode-info">
                <span class="mode-label">{{ 'servicenumber.robot.ai-mode-priority' | i18n }}</span>
                <span class="mode-desc">{{ 'servicenumber.robot.ai-mode-priority-desc' | i18n }}</span>
              </div>
              <nz-switch
                formControlName="useRobotPriorityService"
                id="useRobotPriorityService"
                [nzDisabled]="!isRobotAttached"
                testId="personal-robot-priority-service-switch"
              />
            </div>
            <div class="mode-item" [testId]="'mode-item-assist'">
              <div class="mode-info">
                <span class="mode-label">{{ 'servicenumber.robot.ai-mode-assist' | i18n }}</span>
                <span class="mode-desc">{{ 'servicenumber.robot.ai-mode-assist-desc' | i18n }}</span>
              </div>
              <nz-switch
                formControlName="useAssistAI"
                id="useAssistAI"
                [nzDisabled]="!isRobotAttached"
                testId="personal-robot-assist-ai-switch"
              />
            </div>
            <div class="mode-item" [testId]="'mode-item-consult'">
              <div class="mode-info">
                <span class="mode-label">{{ 'servicenumber.robot.ai-mode-consult' | i18n }}</span>
                <span class="mode-desc">{{ 'servicenumber.robot.ai-mode-consult-desc' | i18n }}</span>
              </div>
              <nz-switch
                formControlName="useConsultAI"
                id="useConsultAI"
                [nzDisabled]="!isRobotAttached"
                testId="personal-robot-consult-ai-switch"
              />
            </div>
          </div>
        </div>

        <div class="section-card ai-setting-card" [testId]="'ai-setting-card'">
          <div class="section-header section-header-with-switch" [testId]="'ai-setting-card-header'">
            <h4 class="section-title">
              <span class="section-kicker"><i nz-icon nzType="robot" nzTheme="outline"></i></span>
              {{ 'servicenumber.robot.ai-setting-title' | i18n }}
            </h4>
            <label class="section-switch" [attr.for]="'useRobot'">
              <span class="section-switch-label">{{ 'servicenumber.robot.ai-service-status' | i18n }}</span>
              <nz-switch formControlName="useRobot" id="useRobot" [nzDisabled]="true" testId="personal-robot-use-robot-switch" />
            </label>
          </div>
          <div class="section-empty" *ngIf="!isRobotAttached" [testId]="'robot-config-unavailable-tip'">
            <span class="section-empty-icon" aria-hidden="true"><i nz-icon nzType="info-circle" nzTheme="outline"></i></span>
            <div class="section-empty-content">
              <span class="section-empty-text">{{ 'servicenumber.robot.ai-service-open-before-config-tip' | i18n }}</span>
            </div>
          </div>
          <div class="ai-setting-form">
            <nz-form-item [testId]="'ai-setting-robot-item'">
              <nz-form-control>
                <div class="robot-card" [testId]="'robot-card'">
                  <div class="robot-info">
                    <div class="robot-avatar">
                      <i nz-icon nzType="robot" nzTheme="outline"></i>
                    </div>
                    <div class="robot-meta">
                      <div class="robot-headline">
                        <span class="robot-identity-chip" [ngClass]="getRobotIdentityClass()" *ngIf="getRobotIdentityLabel()">
                          {{ getRobotIdentityLabel() }}
                        </span>
                        <span class="robot-status-chip" [ngClass]="getRobotStatusClass()">{{ getRobotStatusLabel() }}</span>
                      </div>
                      <div class="robot-id">{{ 'servicenumber.robot.robot-id' | i18n }}: {{ getRobotIdentifierForCard() }}</div>
                    </div>
                  </div>
                  <div class="robot-actions">
                    <button nz-button type="button" *ngIf="false" (click)="openRobotSelector()" testId="personal-robot-select-robot-button">
                      {{ hasSelectedRobot() ? ('servicenumber.robot.button.change' | i18n) : ('servicenumber.robot.button.select' | i18n) }}
                    </button>
                    <button
                      nz-button
                      nzType="primary"
                      type="button"
                      (click)="openRobotConfig()"
                      [disabled]="!hasSelectedRobot() || aiServiceStatus !== 'Active'"
                      testId="personal-robot-config-button"
                    >
                      {{ 'servicenumber.robot.button.config' | i18n }}
                    </button>
                    <button
                      nz-button
                      type="button"
                      (click)="openCurrentRobotPackageModal()"
                      *ngIf="false"
                      [disabled]="!hasSelectedRobot()"
                      testId="personal-robot-package-button"
                    >
                      {{ 'servicenumber.robot.button.package' | i18n }}
                    </button>
                    <button
                      nz-button
                      type="button"
                      class="danger-ghost"
                      (click)="detachRobot()"
                      *ngIf="false"
                      testId="personal-robot-detach-button"
                    >
                      {{ 'servicenumber.robot.button.detach' | i18n }}
                    </button>
                  </div>
                </div>
                <input type="hidden" formControlName="robotServiceId" testId="personal-robot-service-id-input" />
                <input type="hidden" formControlName="robotId" testId="personal-robot-id-input" />
                <div
                  class="field-error"
                  *ngIf="robotForm.get('robotId')?.invalid && (robotForm.get('robotId')?.dirty || robotForm.get('robotId')?.touched)"
                >
                  {{ 'servicenumber.robot.robot-id-required' | i18n }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="section-card abnormal-section" [testId]="'advanced-abnormal-section'">
          <h4 class="section-title">
            <span class="section-kicker"><i nz-icon nzType="warning" nzTheme="outline"></i></span>
            {{ 'servicenumber.robot.abnormal-condition-settings' | i18n }}
          </h4>
          <div class="section-desc">{{ 'servicenumber.robot.abnormal-condition-settings-desc' | i18n }}</div>

          <div nz-col [nzSpan]="24" *ngIf="false">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-warning' | i18n }}</span>
              </div>
              <div class="control-inline">
                <nz-switch
                  formControlName="useWarning"
                  id="useWarning"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-warning-switch"
                />
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-cumulative-miss' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-cumulative-miss-desc' | i18n }}</span>
              </div>
              <div class="control-inline control-inline-wrap">
                <ng-container *ngIf="robotForm.get('useCumulativeMiss')?.value">
                  <div class="inline-field">
                    <div class="inline-row">
                      <span class="control-inline-label-inline required">{{ 'servicenumber.robot.cumulative-miss-count' | i18n }}</span>
                      <nz-input-number
                        [nzPlaceHolder]="'servicenumber.robot.cumulative-miss-count-required' | i18n"
                        formControlName="cumulativeMissCount"
                        [nzDisabled]="!isRobotAttached"
                        id="cumulativeMissCount"
                        [nzMin]="0"
                        [nzStep]="1"
                        [nzMax]="100"
                        testId="personal-robot-cumulative-miss-count-input"
                      />
                      <span class="inline-unit">{{ 'common.times' | i18n }}</span>
                    </div>
                    <div
                      class="field-error"
                      *ngIf="
                        robotForm.get('cumulativeMissCount')?.invalid &&
                        (robotForm.get('cumulativeMissCount')?.dirty || robotForm.get('cumulativeMissCount')?.touched)
                      "
                    >
                      {{ 'servicenumber.robot.cumulative-miss-count-required' | i18n }}
                    </div>
                  </div>
                </ng-container>
                <nz-switch
                  formControlName="useCumulativeMiss"
                  id="useCumulativeMiss"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-cumulative-miss-switch"
                />
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-continuous-miss' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-continuous-miss-desc' | i18n }}</span>
              </div>
              <div class="control-inline control-inline-wrap">
                <ng-container *ngIf="robotForm.get('useContinuousMiss')?.value">
                  <div class="inline-field">
                    <div class="inline-row">
                      <span class="control-inline-label-inline required">{{ 'servicenumber.robot.continuous-miss-count' | i18n }}</span>
                      <nz-input-number
                        [nzPlaceHolder]="'servicenumber.robot.continuous-miss-count-required' | i18n"
                        formControlName="continuousMissCount"
                        [nzDisabled]="!isRobotAttached"
                        id="continuousMissCount"
                        [nzMin]="0"
                        [nzStep]="1"
                        [nzMax]="100"
                        testId="personal-robot-continuous-miss-count-input"
                      />
                      <span class="inline-unit">{{ 'common.times' | i18n }}</span>
                    </div>
                    <div
                      class="field-error"
                      *ngIf="
                        robotForm.get('continuousMissCount')?.invalid &&
                        (robotForm.get('continuousMissCount')?.dirty || robotForm.get('continuousMissCount')?.touched)
                      "
                    >
                      {{ 'servicenumber.robot.continuous-miss-count-required' | i18n }}
                    </div>
                  </div>
                </ng-container>
                <nz-switch
                  formControlName="useContinuousMiss"
                  id="useContinuousMiss"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-continuous-miss-switch"
                />
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-same-question' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-same-question-desc' | i18n }}</span>
              </div>
              <div class="control-inline control-inline-wrap">
                <ng-container *ngIf="robotForm.get('useSameQuestion')?.value">
                  <div class="inline-field">
                    <div class="inline-row">
                      <span class="control-inline-label-inline required">{{ 'servicenumber.robot.same-question-count' | i18n }}</span>
                      <nz-input-number
                        formControlName="sameQuestionCount"
                        [nzDisabled]="!isRobotAttached"
                        id="sameQuestionCount"
                        [nzMin]="0"
                        [nzStep]="1"
                        [nzMax]="100"
                        [nzPlaceHolder]="'servicenumber.robot.same-question-count-placeholder' | i18n"
                        testId="personal-robot-same-question-count-input"
                      />
                      <span class="inline-unit">{{ 'common.times' | i18n }}</span>
                    </div>
                    <div
                      class="field-error"
                      *ngIf="
                        robotForm.get('sameQuestionCount')?.invalid &&
                        (robotForm.get('sameQuestionCount')?.dirty || robotForm.get('sameQuestionCount')?.touched)
                      "
                    >
                      {{ 'servicenumber.robot.same-question-count-required' | i18n }}
                    </div>
                  </div>
                </ng-container>
                <nz-switch
                  formControlName="useSameQuestion"
                  id="useSameQuestion"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-same-question-switch"
                />
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-same-response' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-same-response-desc' | i18n }}</span>
              </div>
              <div class="control-inline control-inline-wrap">
                <ng-container *ngIf="robotForm.get('useSameResponse')?.value">
                  <div class="inline-field">
                    <div class="inline-row">
                      <span class="control-inline-label-inline required">{{ 'servicenumber.robot.same-response-count' | i18n }}</span>
                      <nz-input-number
                        formControlName="sameResponseCount"
                        [nzDisabled]="!isRobotAttached"
                        id="sameResponseCount"
                        [nzMin]="0"
                        [nzStep]="1"
                        [nzMax]="100"
                        [nzPlaceHolder]="'servicenumber.robot.same-response-count-placeholder' | i18n"
                        testId="personal-robot-same-response-count-input"
                      />
                      <span class="inline-unit">{{ 'common.times' | i18n }}</span>
                    </div>
                    <div
                      class="field-error"
                      *ngIf="
                        robotForm.get('sameResponseCount')?.invalid &&
                        (robotForm.get('sameResponseCount')?.dirty || robotForm.get('sameResponseCount')?.touched)
                      "
                    >
                      {{ 'servicenumber.robot.same-response-count-required' | i18n }}
                    </div>
                  </div>
                </ng-container>
                <nz-switch
                  formControlName="useSameResponse"
                  id="useSameResponse"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-same-response-switch"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 會話管理設置：放到轉人工設置後面，使用卡片樣式顯示 -->
        <div
          class="section-card conversation-section"
          [class.robot-config-locked]="!isRobotAttached"
          [testId]="'conversation-management-section'"
        >
          <h4 class="section-title">
            <span class="section-kicker"><i nz-icon nzType="message" nzTheme="outline"></i></span>
            {{ 'servicenumber.robot.conversation-settings' | i18n }}
          </h4>
          <div class="section-desc">{{ 'servicenumber.robot.conversation-settings-desc' | i18n }}</div>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label required">{{ 'servicenumber.robot.session-timeout' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.session-timeout-desc' | i18n }}</span>
              </div>
              <div class="control-inline control-inline-wrap">
                <div class="inline-field">
                  <div class="inline-row">
                    <nz-input-number
                      formControlName="robotTimeoutTime"
                      [nzDisabled]="!isRobotAttached"
                      id="robotTimeoutTime"
                      [nzMin]="0"
                      [nzStep]="1"
                      [nzMax]="120"
                      [testId]="'robot-timeout-input'"
                      [nzPlaceHolder]="'servicenumber.robot.timeout-time-required' | i18n"
                    />
                    <span class="inline-unit">{{ 'common.minutes' | i18n }}</span>
                  </div>
                  <div
                    class="field-error"
                    *ngIf="
                      robotForm.get('robotTimeoutTime')?.invalid &&
                      (robotForm.get('robotTimeoutTime')?.dirty || robotForm.get('robotTimeoutTime')?.touched)
                    "
                  >
                    {{ 'servicenumber.robot.timeout-time-required' | i18n }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-card sensitive-section" [class.robot-config-locked]="!isRobotAttached" [testId]="'advanced-sensitive-section'">
          <h4 class="section-title">
            <span class="section-kicker"><i nz-icon nzType="safety-certificate" nzTheme="outline"></i></span>
            {{ 'servicenumber.robot.sensitive-words-settings' | i18n }}
          </h4>
          <div class="section-desc">{{ 'servicenumber.robot.sensitive-words-settings-desc' | i18n }}</div>
          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-sensitive-words' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-sensitive-words-desc' | i18n }}</span>
              </div>
              <div class="control-inline">
                <nz-switch
                  formControlName="useSensitiveWords"
                  id="useSensitiveWords"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-sensitive-words-switch"
                />
              </div>
            </div>
          </div>
          <div class="section-empty" *ngIf="!robotForm.get('useSensitiveWords')?.value">
            <span class="section-empty-icon" aria-hidden="true">
              <i nz-icon nzType="warning" nzTheme="outline"></i>
            </span>
            <div class="section-empty-content">
              <span class="section-empty-text">{{ 'servicenumber.robot.sensitive-words-disabled-tip' | i18n }}</span>
            </div>
          </div>

          <ng-container *ngIf="robotForm.get('useSensitiveWords')?.value">
            <div nz-col [nzSpan]="24">
              <div class="abnormal-item">
                <div class="item-info">
                  <span class="item-label">{{ 'servicenumber.robot.enable-sensitive-words-handover' | i18n }}</span>
                  <span class="section-desc">{{ 'servicenumber.robot.enable-sensitive-words-handover-checked' | i18n }}</span>
                  <span class="section-desc">{{ 'servicenumber.robot.enable-sensitive-words-handover-unchecked' | i18n }}</span>
                </div>
                <div class="control-inline">
                  <nz-switch
                    formControlName="useSensitiveWordsWarning"
                    id="useSensitiveWordsWarning"
                    testId="personal-robot-use-sensitive-words-warning-switch"
                  />
                </div>
              </div>
            </div>

            <div nz-col [nzSpan]="24">
              <div class="abnormal-item">
                <div class="item-info">
                  <span class="item-label required">{{ 'servicenumber.robot.sensitive-words-count' | i18n }}</span>
                  <span class="section-desc"> {{ 'servicenumber.robot.sensitive-words-count-desc' | i18n }}</span>
                </div>
                <div class="control-inline control-inline-wrap">
                  <div class="inline-field">
                    <div class="inline-row">
                      <nz-input-number
                        formControlName="sensitiveWordsCount"
                        [nzDisabled]="!isRobotAttached"
                        id="sensitiveWordsCount"
                        [nzMin]="0"
                        [nzStep]="1"
                        [nzMax]="100"
                        [nzPlaceHolder]="'servicenumber.robot.sensitive-words-count-placeholder' | i18n"
                        testId="personal-robot-sensitive-words-count-input"
                      />
                      <span class="inline-unit">{{ 'common.times' | i18n }}</span>
                    </div>
                    <div
                      class="field-error"
                      *ngIf="
                        robotForm.get('sensitiveWordsCount')?.invalid &&
                        (robotForm.get('sensitiveWordsCount')?.dirty || robotForm.get('sensitiveWordsCount')?.touched)
                      "
                    >
                      {{ 'servicenumber.robot.sensitive-words-count-required' | i18n }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div nz-col [nzSpan]="24">
              <div class="abnormal-item textarea-item">
                <div class="item-info">
                  <span class="item-label">{{ 'servicenumber.robot.sensitive-words-reply-text' | i18n }}</span>
                  <span class="section-desc">{{ 'servicenumber.robot.sensitive-words-reply-text-desc' | i18n }}</span>
                </div>
                <div class="control-block">
                  <textarea
                    nz-input
                    formControlName="sensitiveWordsReplyText"
                    [disabled]="!isRobotAttached"
                    id="sensitiveWordsReplyText"
                    [placeholder]="'servicenumber.robot.sensitive-words-reply-text-placeholder' | i18n"
                    [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                    testId="personal-robot-sensitive-words-reply-textarea"
                  ></textarea>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="section-card greeting-section" [class.robot-config-locked]="!isRobotAttached" [testId]="'advanced-greeting-section'">
          <h4 class="section-title">
            <span class="section-kicker"><i nz-icon nzType="notification" nzTheme="outline"></i></span>
            {{ 'servicenumber.robot.greeting-settings' | i18n }}
          </h4>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-greeting' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-greeting-desc' | i18n }}</span>
              </div>
              <div class="control-inline">
                <nz-switch
                  formControlName="useGreetingQuestion"
                  id="useGreetingQuestion"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-greeting-question-switch"
                />
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24" *ngIf="robotForm.get('useGreetingQuestion')?.value">
            <div class="abnormal-item textarea-item">
              <div class="item-info">
                <span class="item-label required">{{ 'servicenumber.robot.greeting-text' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.greeting-text-desc' | i18n }}</span>
              </div>
              <div class="control-block">
                <textarea
                  nz-input
                  formControlName="greetingQuestionText"
                  [disabled]="!isRobotAttached"
                  id="greetingQuestionText"
                  [placeholder]="'servicenumber.robot.greeting-text-placeholder' | i18n"
                  [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                  [attr.maxlength]="greetingQuestionMaxLength"
                  testId="personal-robot-greeting-question-textarea"
                ></textarea>
              </div>
              <div class="field-meta"
                >{{ (robotForm.get('greetingQuestionText')?.value || '').length }}/{{ greetingQuestionMaxLength }}</div
              >
              <div
                class="field-error"
                *ngIf="
                  robotForm.get('greetingQuestionText')?.invalid &&
                  (robotForm.get('greetingQuestionText')?.dirty || robotForm.get('greetingQuestionText')?.touched)
                "
              >
                {{ getGreetingQuestionErrorKey() | i18n }}
              </div>
            </div>
          </div>
        </div>

        <div class="section-card handover-section" [class.robot-config-locked]="!isRobotAttached" [testId]="'advanced-handover-section'">
          <h4 class="section-title">
            <span class="section-kicker"><i nz-icon nzType="swap" nzTheme="outline"></i></span>
            {{ 'servicenumber.robot.handover-settings' | i18n }}
          </h4>
          <div class="section-desc">{{ 'servicenumber.robot.handover-settings-desc' | i18n }}</div>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-handover-text' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-handover-text-desc' | i18n }}</span>
              </div>
              <div class="control-inline">
                <nz-switch
                  formControlName="useHandOverText"
                  id="useHandOverText"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-handover-text-switch"
                />
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24" *ngIf="robotForm.get('useHandOverText')?.value">
            <div class="abnormal-item textarea-item">
              <div class="item-info">
                <span class="item-label required">{{ 'servicenumber.robot.handover-text' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.handover-text-desc' | i18n }}</span>
              </div>
              <div class="control-block">
                <textarea
                  nz-input
                  formControlName="handOverText"
                  [disabled]="!isRobotAttached"
                  id="handOverText"
                  [placeholder]="'servicenumber.robot.handover-text-placeholder' | i18n"
                  [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                  testId="personal-robot-handover-text-textarea"
                ></textarea>
              </div>
              <div
                class="field-error"
                *ngIf="
                  robotForm.get('handOverText')?.invalid && (robotForm.get('handOverText')?.dirty || robotForm.get('handOverText')?.touched)
                "
              >
                {{ 'servicenumber.robot.handover-text-required' | i18n }}
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24">
            <div class="abnormal-item">
              <div class="item-info">
                <span class="item-label">{{ 'servicenumber.robot.enable-handover-reply' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.enable-handover-reply-desc' | i18n }}</span>
              </div>
              <div class="control-inline">
                <nz-switch
                  formControlName="useHandOverTextReply"
                  id="useHandOverTextReply"
                  [nzDisabled]="!isRobotAttached"
                  testId="personal-robot-use-handover-reply-switch"
                />
              </div>
            </div>
          </div>

          <div nz-col [nzSpan]="24" *ngIf="robotForm.get('useHandOverTextReply')?.value">
            <div class="abnormal-item textarea-item">
              <div class="item-info">
                <span class="item-label required">{{ 'servicenumber.robot.handover-reply-text' | i18n }}</span>
                <span class="section-desc">{{ 'servicenumber.robot.handover-reply-text-desc' | i18n }}</span>
              </div>
              <div class="control-block">
                <textarea
                  nz-input
                  formControlName="handOverTextReplyText"
                  [disabled]="!isRobotAttached"
                  id="handOverTextReplyText"
                  [placeholder]="'servicenumber.robot.handover-reply-text-placeholder' | i18n"
                  [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                  testId="personal-robot-handover-reply-textarea"
                ></textarea>
              </div>
              <div
                class="field-error"
                *ngIf="
                  robotForm.get('handOverTextReplyText')?.invalid &&
                  (robotForm.get('handOverTextReplyText')?.dirty || robotForm.get('handOverTextReplyText')?.touched)
                "
              >
                {{ 'servicenumber.robot.handover-reply-text-required' | i18n }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </nz-spin>
</div>
